import * as Models from '../../models/commonModels';

export class Download {
  static readonly type = '[Document] Download';
  constructor(public Id: Models.RequestModel) { }
}

